import { AxiosRequestConfig } from "axios";
import axios from "../helpers/axiosInterceptor";
import { Endpoints } from "../constants/Endpoints";

interface FieldValuePair {
  Field: string;
  Value: string;
}

/**
 * Gets tire raw sizes
 * - No brand & model → returns ALL
 * - Brand only → filter by brand
 * - Brand + model → filter by both
 */
export const GetRawSizeByModel = async (
  brand?: string,
  model?: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const body: FieldValuePair[] = [];

    if (brand && brand.trim() !== "") {
      body.push({
        Field: "brand",
        Value: brand,
      });
    }

    if (model && model.trim() !== "") {
      body.push({
        Field: "model",
        Value: model,
      });
    }

    // POST with empty body is intentional → backend returns all
    const response: any = await axios.post(
      Endpoints.GetRawSizesByModel,
      body,
      config
    );

    if (response?.data?.Success === 0 && response?.data?.ErrorCode === 1) {
      console.error("Unexpected error.");
      throw new Error("Unexpected error");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching raw sizes:", error);
    throw error;
  }
};
